import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsCompany from "graphql/fields/FieldsCompany";

const fields = {
	'guid': 'String!',
};

export default gql(`
	query company( ${ HelperGraphql.createFields( fields ) } ) {
		company( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsCompany}
		}
	}
`);

